export const RESEND_COUNTDOWN = 60
